export const sections = [
  { id: "#home", label: "home" },
  { id: "#about", label: "about" },
  { id: "#projects", label: "projects" },
  { id: "#publications", label: "publications" },
  { id: "#contact", label: "contact" },
];

export const skillBadges = [
  {
    src: "https://img.shields.io/badge/angular-%23DD0031.svg?style=for-the-badge&logo=angular&logoColor=white",
    alt: "Angular",
  },
  {
    src: "https://img.shields.io/badge/TypeScript-3178C6?style=for-the-badge&logo=typescript&logoColor=white",
    alt: "TypeScript",
  },
  {
    src: "https://img.shields.io/badge/JavaScript-F7DF1E?style=for-the-badge&logo=javascript&logoColor=black",
    alt: "JavaScript",
  },
  {
    src: "https://img.shields.io/badge/CSS-1572B6?style=for-the-badge&logo=css3&logoColor=white",
    alt: "CSS",
  },
  {
    src: "https://img.shields.io/badge/HTML-E34F26?style=for-the-badge&logo=html5&logoColor=white",
    alt: "HTML",
  },
  {
    src: "https://img.shields.io/badge/React-61DAFB?style=for-the-badge&logo=react&logoColor=black",
    alt: "React",
  },
  {
    src: "https://img.shields.io/badge/Jest-C21325?style=for-the-badge&logo=jest&logoColor=white",
    alt: "Jest",
  },
  {
    src: "https://img.shields.io/badge/java-%23ED8B00.svg?style=for-the-badge&logo=openjdk&logoColor=white",
    alt: "Java",
  },
  {
    src: "https://img.shields.io/badge/spring-%236DB33F.svg?style=for-the-badge&logo=spring&logoColor=white",
    alt: "Spring",
  },
  {
    src: "https://img.shields.io/badge/Rails-CC0000?style=for-the-badge&logo=ruby-on-rails&logoColor=white",
    alt: "Ruby on Rails",
  },
  {
    src: "https://img.shields.io/badge/Ruby-CC342D?style=for-the-badge&logo=ruby&logoColor=white",
    alt: "Ruby",
  },
  {
    src: "https://img.shields.io/badge/Postgres-336791?style=for-the-badge&logo=postgresql&logoColor=white",
    alt: "PostgreSQL",
  },
];

export const projects = [
  {
    imageSrc:
      "https://res.cloudinary.com/drenq2n4a/image/upload/v1736469369/z0eqpd0na6d1a41hvjkh.png",
    imageAlt: "weather_radar_title",
    title: "weather_radar_title",
    description: "weather_radar_description",
    githubLink: "https://github.com/VitorComin/weather-radar",
    previewLink: "https://vitorcomin.github.io/weather-radar/#/",
  },
  {
    imageSrc:
      "https://res.cloudinary.com/drenq2n4a/image/upload/v1740095525/ddidcfvggggwxt5ebnxk.png",
    imageAlt: "simple_kanban_project",
    title: "simple_kanban_project",
    description: "simple_kanban_description",
    githubLink: "https://github.com/VitorComin/simple-react-kanban",
    previewLink: "https://vitorcomin.github.io/simple-react-kanban/",
  },
  {
    imageSrc:
      "https://res.cloudinary.com/drenq2n4a/image/upload/v1745881614/wmahpoxzs6gras7v0yvc.png",
    imageAlt: "wms_portal_title",
    title: "wms_portal_title",
    description: "wms_portal_description",
    githubLink: "https://github.com/VitorComin/wms-portal",
    previewLink: "https://vitorcomin.github.io/wms-portal/",
  },
];

export const publications = [
  {
    imageSrc:
      "https://res.cloudinary.com/drenq2n4a/image/upload/v1777508620/artig_mlyxpd.png",
    imageAlt: "state_management_article_title",
    title: "state_management_article_title",
    description: "state_management_article_description",
    previewLink: "https://doi.org/10.5753/reic.2026.7413",
  },
];

// {
//   imageSrc:
//     "https://res.cloudinary.com/drenq2n4a/image/upload/v1739404087/tbqlpexki9fuvcxnkkbu.png",
//   imageAlt: "cimefer_group_site",
//   title: "cimefer_group_site",
//   description: "cimefer_group_description",
//   previewLink: "https://www.cimefergroup.com.br",
// }
